export const NOTIFICATION_DANGER = 'danger';

export const NOTIFICATION_SUCCESS = 'success';

export const NOTIFICATION_INFO = 'info';
